import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import {
  DIETARY as FALLBACK_DIETARY,
  applicableDietary as applicableFromList,
} from "@/lib/dietary";

const DietaryContext = createContext(null);

export function DietaryProvider({ children }) {
  // Seed with the static fallback so first paint is instant; replace with
  // the backend's authoritative list on mount.
  const [legend, setLegend] = useState(FALLBACK_DIETARY);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/dietary-legend");
        if (!cancelled && Array.isArray(data) && data.length > 0) {
          setLegend(data);
        }
      } catch (_e) {
        /* keep fallback */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo(
    () => ({
      legend,
      byCode: Object.fromEntries(legend.map((d) => [d.code, d])),
      applicable: (tags) => applicableFromList(tags, legend),
    }),
    [legend],
  );

  return <DietaryContext.Provider value={value}>{children}</DietaryContext.Provider>;
}

export function useDietary() {
  return useContext(DietaryContext) || {
    legend: FALLBACK_DIETARY,
    byCode: Object.fromEntries(FALLBACK_DIETARY.map((d) => [d.code, d])),
    applicable: (tags) => applicableFromList(tags, FALLBACK_DIETARY),
  };
}
